import { t } from '@lingui/macro';

const DUPLICATE_IMG_STR = 'Photo already exists with this attachment';

export const getErrorMessage = (
    eMsg: { message: string; code?: number; reason?: string },
    message: string
) => {
    /* No default here:
     *  1. We check for the code
     *  2. We check for the reason
     *  3. We check for the message
     *  4. If neither the code nor message matches we return the normal message */
    if (eMsg.code) {
        switch (eMsg.code) {
            case 1:
                return t`Location must be active to comply with regulations.`;
        }
    }

    if (eMsg.reason) {
        if (eMsg.reason.includes(DUPLICATE_IMG_STR)) {
            return t`Image already used for this installation, please use a fresh image.`;
        }
    }

    switch (eMsg.message) {
        case 'Given data is not jpeg.':
            return t`The image uploaded is not a valid jpeg.`;
        default:
            return message;
    }
};
